module.exports = __webpack_public_path__ + "img/settings.595ec377.svg";